<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نمایش پروژه های نصاب</h6>
            <router-link v-if="can('installer.reports.history')" :to="{
                name:'installer.reports.history',
                params: { id: this.$route.params.id }
              }" class="btn btn-outline-dark">
              تاریخچه گزارش ها
            </router-link>
            <router-link v-if="can('installer.reports')" :to="{
                name:'installer.reports',
                params: { id: this.$route.params.id }
              }" class="btn btn-outline-success">
              پرینت
            </router-link>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null" >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>کد پروژه</th>
                  <th>عنوان</th>
                  <th>وضعیت</th>
                  <th>نام متریال</th>
                  <th>تاریخ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(attr , index) in data" :key="index">
                  <td>{{index+1}}</td>
                  <td v-text="attr.project.code"></td>
                  <td v-text="attr.project.name"></td>
                  <td>
                    <button class="btn btn-success" v-if="attr.pay" @click="pay(0, attr.id)">تسویه شده</button>
                    <button class="btn btn-danger" v-else @click="pay(1, attr.id)">تسویه نشده</button>
                  </td>
                   <td >
                   <button
                        type="button"
                        class="btn btn-outline-primary"
                        data-toggle="modal"
                        :data-target="'#materialProperty' + attr.id">
                        {{ attr.material.name }}
                      </button>
                      <attribute :attr="attr" :properties="properties" :attrIndex="index" :name="attr.material.name" :property_default="property_default"></attribute>
                    </td>
                    <td v-text="attr.date"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                 <th>ردیف</th>
                  <th>کد پروژه</th>
                  <th>عنوان</th>
                  <th>وضعیت</th>
                  <th>نام متریال</th>
                  <th>تاریخ</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import attribute from '@/components/project/material/Attribute.vue'
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'InstallerProjects',
  mixins: [pagination],
  components: {
    paginations, attribute
  },
  data () {
    return {
      data: null,
      url: '/api/installer/' + this.$route.params.id + '/projects',
      properties: null,
      property_default: null
    }
  },
  created () {
    this.$send.submit('get', 'api/attribute')
      .then(response => {
        this.properties = response.properties
        this.property_default = response.property_default
      })
  },
  methods: {
    pay (status, id) {
      this.$send.submit('post', 'api/attribute/changePay/' + id)
        .then(response => {
          const num = this.data.findIndex(x => x.id === id)
          this.data[num].pay = status
          if (status === 1) {
            // eslint-disable-next-line no-undef
            swal(
              'تبریک!',
              'وضعیت پرداخت به تصفیه شده تغییر کرد!',
              'success', {
                button: 'باشه'
              })
          } else {
            // eslint-disable-next-line no-undef
            swal(
              'تبریک!',
              'وضعیت پرداخت به تصفیه نشده تغییر کرد!',
              'warning', {
                button: 'باشه'
              })
          }
        })
    }
  }
}

</script>
